var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w100 Overview" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.Loading,
              expression: "Loading",
            },
          ],
          staticClass: "search-top",
        },
        [
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "260px" },
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "请选择供应商",
                  },
                  model: {
                    value: _vm.searchData.SupplierId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchData, "SupplierId", $$v)
                    },
                    expression: "searchData.SupplierId",
                  },
                },
                _vm._l(_vm.SupplierData, function (item) {
                  return _c("el-option", {
                    key: item.Id,
                    attrs: { label: item.title, value: item.Id },
                  })
                }),
                1
              ),
              _c("el-input", {
                staticStyle: { width: "260px", "margin-left": "10px" },
                attrs: { clearable: "", placeholder: "请输入设备名称/编号" },
                model: {
                  value: _vm.searchData.Device,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchData, "Device", $$v)
                  },
                  expression: "searchData.Device",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "260px", "margin-left": "10px" },
                attrs: { clearable: "", placeholder: "请输入备件名称/编号" },
                model: {
                  value: _vm.searchData.Accessory,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchData, "Accessory", $$v)
                  },
                  expression: "searchData.Accessory",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.getDataList },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.Loading,
              expression: "Loading",
            },
          ],
          staticClass: "table-ove",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.Data, "header-row-class-name": "table-tit" },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "序号",
              width: "55",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "DeviceCode", label: "设备编号", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "DeviceName", label: "设备名称", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "AccessoryCode",
              label: "备件编号",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "AccessoryName",
              label: "备件名称",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "TypeName", label: "备件类型", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "AccessorySpec",
              label: "备件规格",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "SupplierName",
              label: "供应商名称",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "Supplier", label: "生产厂家名称", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "AccessoryNum",
              label: "备件数量",
              align: "right",
              width: "100",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }